import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import router from './router'

// Import Inter weights (400 for body, 600 for headings)
import "@fontsource/inter/400.css"
import "@fontsource/inter/600.css"


const app = createApp(App)

app.use(router) // Tell Vue to use the router
app.mount('#app')
